import React, { useId } from 'react';

interface Props {
  className?: string;
}

const WixelLogoAndText: React.FC<Props> = ({ className }) => {
  const gradientAId = useId();
  const gradientBId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="21"
      viewBox="0 0 80 21"
      fill="none"
      className={className}
    >
      <path fill={`url(#${gradientAId})`} d="M.5 0h14.98v14.98H.5z"></path>
      <path
        fill={`url(#${gradientBId})`}
        d="M5.92 5.42h14.97v13.07a1.9 1.9 0 0 1-1.9 1.9H5.92z"
      ></path>
      <path fill="#5AD87B" d="M7.87 7.37h5.53v5.53H7.87z"></path>
      <path
        fill="currentColor"
        d="m69.5 13.1-7.92.02q-.36 0-.36-.36l-.12-1.53q0-.36.36-.36l7.92-.02c.59 0 .82-.24.7-.83-.23-1.18-1.65-2.48-3.53-2.48-2.97.02-4.15 2.15-4.15 4.4 0 4.72 5.53 5.76 8.36 3.04a.36.36 0 0 1 .47 0l1.06 1.19c.12.11.12.35 0 .47-3.77 3.9-12.25 2.5-12.25-4.94 0-3.31 2.38-6.4 6.27-6.4 3.18 0 5.54 1.77 6.13 4.72.35 2.25-.94 3.07-2.95 3.07ZM33.87 9.3h.47v.25h-.47zm3.89 4.86h.47v.22h-.47zm-7.78 0h.47v.22H30v-.22Zm23.83-.37h.47v.26h-.47zm0-4h.47v.22h-.47V9.8Zm5.66-3.68-4.01 5.8 4 5.7c.23.34.12.7-.36.7h-1.18c-.58 0-1.06-.24-1.41-.7l-2.47-3.7-2.48 3.7c-.35.46-.82.7-1.41.7h-1.18c-.47 0-.57-.35-.36-.7l4.02-5.7-4-5.8c-.24-.35-.13-.7.35-.7h1.3c.58 0 1.05.35 1.4.82l2.36 3.66 2.36-3.66c.35-.47.81-.82 1.42-.82h1.3c.46 0 .58.35.35.7M34 5.42h.23c.71 0 1.06.35 1.3.94l2.48 8.03 2.35-8.03c.24-.59.6-.94 1.3-.94h.7c.36 0 .6.23.48.7l-2.98 10.3c-.35 1.43-1.06 1.9-1.88 1.9-.83 0-1.54-.6-1.9-1.9l-1.96-7.1-2.04 7.1c-.35 1.3-1.06 1.9-1.89 1.9-.82 0-1.53-.47-1.88-1.9l-2.92-10.3c-.11-.47.12-.7.48-.7h.82c.7 0 1.18.47 1.3 1.06l2.24 7.91 2.47-8.03c.24-.59.6-.94 1.3-.94m11.45-1.54c.94 0 1.65-.71 1.65-1.65 0-.95-.71-1.66-1.65-1.66-.95 0-1.65.71-1.65 1.66 0 .94.7 1.65 1.65 1.65m32.2 14.67h1.29c.23 0 .34-.11.34-.35v-1.72c0-.24-.1-.35-.34-.35h-1.27c-.69 0-1.15-.46-1.15-1.15V.35c0-.23-.12-.35-.35-.35h-1.72c-.24 0-.35.12-.35.35v14.63c0 2.25 1.3 3.57 3.54 3.57Zm-33.4-.58V5.77c0-.24.12-.35.35-.35h1.73c.23 0 .35.11.35.34v12.21c0 .23-.12.35-.35.35H44.6c-.23 0-.34-.12-.34-.35Z"
      ></path>
      <defs>
        <linearGradient
          id={gradientAId}
          x1="7.99"
          x2="7.99"
          y1="0"
          y2="14.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBA8A"></stop>
          <stop offset="1" stopColor="#FF90E6"></stop>
        </linearGradient>
        <linearGradient
          id={gradientBId}
          x1="13.41"
          x2="17.21"
          y1="5.42"
          y2="21.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C95F7"></stop>
          <stop offset="1" stopColor="#4B319C"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

WixelLogoAndText.displayName = 'WixelLogoAndText';

export default WixelLogoAndText;
